import React from "react";
import ConfirmDialog from "./ConfirmDialog";

/** A delete confirmation, drawn by the shared ConfirmDialog. */
export function ConfirmDeleteModal(props) {
    return (
        <ConfirmDialog
            open={!!props.show}
            danger
            title={props.title}
            message={props.message}
            onConfirm={props.onDelete}
            onCancel={props.onHide}
        />
    )
}
